import { trackGtmEvent } from '@/app/_lib/utils/ndrUtils';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import type { LandingPage } from '@/app_data/mock/ndrData';
import { DescriptionParser } from '@/app_lib/htmlParser/DescriptionParser';
import { trackOptimizelyEvent } from '@/app_lib/optimizely/utils';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';

interface NdrHeroProps {
  data: LandingPage;
  isTop5?: boolean;
  queryParams?: string;
  className?: string;
}

export const NdrHero = ({ data, queryParams, className = '', isTop5 = false }: NdrHeroProps) => {
  const { optimizely } = useOptimizely();
  const title = isTop5 && data.topLandingPageTitle ? data.topLandingPageTitle : data.landingPageTitle;
  const cta = isTop5 && data.topCta ? data.topCta : data.primaryCta;
  const description = isTop5 && data.topLandingPageDek ? data.topLandingPageDek : data.landingPageDek;

  return (
    <section className={`w-full flex flex-col layout-gap-md p-default ${className}`}>
      <div className='flex flex-col gap-xl text-center'>
        <h1
          className='typography-lg font-semibold'
          data-cy='ndr-hero-title'
        >
          {title}
        </h1>
        <div
          className='max-w-[var(--width-md)] flex flex-col gap-xl typography-level-6 mx-auto'
          data-cy='ndr-hero-description'
        >
          <DescriptionParser content={description} />
        </div>
      </div>
      <div className='flex flex-col gap-md justify-center items-center'>
        <ButtonV2
          data-cy='ndr-hero-primary-cta'
          href={`${cta.url}${queryParams ? `?${queryParams}` : ''}`}
          onClick={() => {
            trackOptimizelyEvent(optimizely, 'ndr_compare_top_option_click', {});
            trackGtmEvent(`${cta.url}${queryParams ? `?${queryParams}` : ''}`);
          }}
        >
          {cta.text}
        </ButtonV2>
        <span
          className='text-sm'
          data-cy='ndr-hero-note'
        >
          {data.note}
        </span>
      </div>
    </section>
  );
};
